export default "__VITE_ASSET__CPa6jiTM__"